import React from 'react';
import { useColorScheme } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { PaperProvider } from 'react-native-paper';
import { AuthProvider, useAuth } from './src/context/AuthContext';
import LoginScreen from './src/screens/LoginScreen';
import MainNavigator from './src/navigation/MainNavigator';
import DriverNavigator from './src/navigation/DriverNavigator';
import lightTheme, { darkTheme } from './src/theme/theme';
import 'react-native-gesture-handler';
import { enGB, registerTranslation } from 'react-native-paper-dates';
import TruckDetailScreen from './src/screens/TruckDetailScreen';
import { Truck } from './src/types/Truck';

// Register date picker locale
registerTranslation('en-GB', enGB);

export type RootStackParamList = {
  Main: undefined;
  DriverMain: undefined;
  Login: undefined;
  TruckDetail: { truck: Truck };
};

const Stack = createStackNavigator<RootStackParamList>();

const AppNavigator = () => {
  const { user, loading, role } = useAuth();

  console.log(
    'AppNavigator - Loading:',
    loading,
    'User:',
    user ? 'Logged in' : 'Not logged in',
    'Role:',
    role,
  );

  if (loading) return null;

  return (
    <NavigationContainer>
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
          gestureEnabled: true,
        }}
      >
        {user && role ? (
          role === 'driver' ? (
            <Stack.Screen name="DriverMain" component={DriverNavigator} />
          ) : (
            <>
              <Stack.Screen name="Main" component={MainNavigator} />
              <Stack.Screen name="TruckDetail" component={TruckDetailScreen} />
            </>
          )
        ) : (
          <Stack.Screen name="Login" component={LoginScreen} />
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
};

function App() {
  const scheme = useColorScheme();
  const theme = scheme === 'dark' ? darkTheme : lightTheme;
  return (
    <SafeAreaProvider>
      <PaperProvider theme={theme}>
        <AuthProvider>
          <AppNavigator />
        </AuthProvider>
      </PaperProvider>
    </SafeAreaProvider>
  );
}

export default App;
